/**
 * Конфигурация прототипа — runtime + build-time.
 * Приоритет: build-time env (VITE_*) → /config/yandex-tiles.json → defaults
 */

// GeoServer (FR-MAP-04, FR-MAP-19)
// При запуске через Vite dev — относительный путь '/geoserver' проксируется на VITE_GEOSERVER_URL
// В production за nginx — тоже '/geoserver'
export const GEOSERVER_URL = import.meta.env.VITE_GEOSERVER_URL || '/geoserver';
export const GEOSERVER_WORKSPACE = 'catrus';

// FastAPI backend (опционален — если не отвечает, переходим на mock)
export const API_URL = import.meta.env.VITE_API_URL || '/api/v1';

// Гейт доступа (ЧТЗ-AUTH-005, FR-AUTH-23). Приходит строкой — нормализуем.
// Не задано → false (открыто), чтобы не ломать локальную разработку.
export const REQUIRE_AUTH = ['true', '1'].includes(
  String(import.meta.env.VITE_REQUIRE_AUTH ?? '').toLowerCase()
);

// Имена слоёв в GeoServer (точно по ТЗ FR-MAP-19)
export const LAYERS = {
  L1: `${GEOSERVER_WORKSPACE}:seismic_osr2015a`,
  // L2 — справочный слой гидрографии (реки + водоёмы). Слой наводнений
  // (flood_zones_1pct) упразднён как карта: оценка наводнения теперь атрибутивная
  // (класс 0–5 в правой панели опасностей), а не WMS-слой.
  L2: `${GEOSERVER_WORKSPACE}:river_network`,
  L3: `${GEOSERVER_WORKSPACE}:landslide_zones`,
  L4: `${GEOSERVER_WORKSPACE}:buildings_osm`,
};

// Стартовая точка для прототипа — Иркутск, ул. Ленина, 5
// (по ТЗ FR-MAP-02 центр lon=100°E, lat=62°N, zoom=3.2 — для прод; для прототипа фокусируемся на пилоте)
export const INITIAL_VIEW = {
  center: [104.305, 52.286], // WGS84
  zoom: 11,
  minZoom: 3,
  maxZoom: 19,
};

// Координаты объекта для дашборда
export const FOCUS_OBJECT = {
  name: 'ул. Ленина, 5',
  city: 'Иркутск',
  lon: 104.3050,
  lat: 52.2864,
};

/**
 * Загружает Yandex Tiles конфиг из /config/yandex-tiles.json
 * Если файл отсутствует или содержит placeholder — возвращает null
 */
export async function loadYandexConfig() {
  // 1. Сначала пробуем build-time env (для prod-сборки)
  if (import.meta.env.VITE_YANDEX_TILES_API_KEY) {
    return {
      apikey: import.meta.env.VITE_YANDEX_TILES_API_KEY,
      lang: import.meta.env.VITE_YANDEX_TILES_LANG || 'ru_RU',
      layer: import.meta.env.VITE_YANDEX_TILES_LAYER || 'map',
    };
  }
  // 2. Затем runtime-конфиг из public/config
  try {
    const resp = await fetch('/config/yandex-tiles.json', { cache: 'no-store' });
    if (!resp.ok) return null;
    const cfg = await resp.json();
    if (!cfg.apikey || cfg.apikey.startsWith('REPLACE_')) return null;
    return cfg;
  } catch {
    return null;
  }
}
